import { useTranslation } from 'react-i18next';
import css from './StockEquipmentItem.module.scss';
import React, { useMemo } from 'react';
import { RouteComponentProps } from '@reach/router';
import { StockEquipment } from '../../../interfaces/customer-api';
import { EquipmentType } from '../../../interfaces/internal';

const contacts = {
    [EquipmentType.TERMINAL_TRACTOR]: 'dorin.timircan@kalmarglobal.com',
    [EquipmentType.COUNTER_BALANCED]: 'cbglobalsales@kalmarglobal.com',
    [EquipmentType.EMPTY_CONTAINER_HANDLER]: 'cbglobalsales@kalmarglobal.com',
    [EquipmentType.FORKLIFT_TRUCK]: 'cbglobalsales@kalmarglobal.com',
    [EquipmentType.REACHSTACKER]: 'cbglobalsales@kalmarglobal.com',
    [EquipmentType.ROUGH_TERRAIN_CONTAINER_HANDLER]: 'cbglobalsales@kalmarglobal.com',
    [EquipmentType.OTHER]: 'mykalmar.support@kalmarglobal.com',
};
interface StockEquipmentContactProps extends RouteComponentProps {
    stockEquipment: StockEquipment;
}
export const StockEquipmentContact: React.FC<StockEquipmentContactProps> = (props: StockEquipmentContactProps) => {
    const { t } = useTranslation('StockEquipment');
    const { stockEquipment } = props;
    
    const email = useMemo(() => {
        if (stockEquipment?.contactEmail) {
            return stockEquipment.contactEmail;
        }
        if (stockEquipment && stockEquipment.type) {
            return contacts[stockEquipment.type as EquipmentType] || contacts[EquipmentType.OTHER];
        }
        return contacts[EquipmentType.OTHER];
    }, [stockEquipment]);

    if (!stockEquipment || stockEquipment.id === null) {
        return <p className={css.myEquipmentItem}>{t('No equipment found')}</p>;
    }

    return (
        <>
            <h3>{t('Contact')}</h3>
            <div className={css.borderedBox}>
                {t('If you are interested in this equipment, please contact your local Kalmar sales representative or email us at')}
                <a href={`mailto:${email}`} className={css.email}>
                    {email}
                </a>
            </div>
        </>
    );
};
